export default {"src":"/_next/static/media/volleybal.3e4be4fe.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};